<template>
  <div class="reverseInvoiceList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="customerInvoiceInfo">
      <template slot="adSearch">
        <vm-search label="客户名称">
          <el-input v-model="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="客户编号">
          <el-input v-model="filter.customerNo" clearable/>
        </vm-search>
      </template>
      <el-table-column align="center" prop="customerNo" label="客户编号" width="200"/>
      <el-table-column align="center" prop="customerName" label="客户名称" width="200"/>
      <el-table-column align="center" prop="taxId" label="税号" width="200"/>
      <el-table-column align="center" prop="invoiceAddress" label="开票地址" width="200"/>
      <el-table-column align="center" prop="invoiceAccount" label="开票账户" width="200"/>
      <el-table-column
          align="center"
          prop="invoiceEmail"
          show-overflow-tooltip
          label="邮箱"
          width="200"/>
      <el-table-column align="center" prop="updateTime" label="更新时间" width="200"/>
      <el-table-column label="操作" width="200px" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
              type="primary"
              @click="goto(scope.row)">
            编辑
          </el-button>
          <el-button type="danger" @click="deleteOne(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <el-dialog
        v-el-drag-dialog
        width="800px"
        :visible.sync="visible"
        :close-on-click-modal="false"
        title="客户开票信息">
      <el-form
          ref="form"
          :model="form"
          class="form"
          label-width="120px">
        <el-form-item label="客户名称">
          <el-input v-model.trim="form.customerName"/>
        </el-form-item>
        <el-form-item label="税号">
          <el-input v-model.trim="form.taxId"/>
        </el-form-item>
        <el-form-item label="税号">
          <el-input v-model.trim="form.taxId"/>
        </el-form-item>
        <el-form-item label="开票地址">
          <el-input v-model.trim="form.invoiceAddress"/>
        </el-form-item>
        <el-form-item label="开票账户">
          <el-input v-model.trim="form.invoiceAccount"/>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model.trim="form.invoiceEmail"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button :loading="saveLoading" type="primary" @click="save(form)">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "CustomerInvoiceInfoList",
    components: {VmTable, VmSearch},
    data() {
      return {
        selection: [],
        visible: false,
        saveLoading:false,
        filter: {
          customerName: "",
          customerNo: "",
        },
        form: {},
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      save() {
        this.saveLoading=true;
        this.$http.put("basic","customerInvoiceInfo",this.form)
          .then(()=>{
            this.$message.success("保存成功");
          }).finally(()=>{
            this.visible=false;
            this.saveLoading=false;
            this.getList();
          });
      },

      goto(row) {
        this.form=row;
        this.visible=true;
      },

      deleteOne(row) {
        this.$http.delete("basic","customerInvoiceInfo",row.pkId) .then(()=>{
          this.$message.success("删除成功");
        }).finally(()=>{
          this.getList();
        });
      },

    },
  };
</script>
<style lang="scss">
</style>
